module.exports = __webpack_public_path__ + "static/media/sport2.7d1ffeaa.jpg";